module.exports = __webpack_public_path__ + "fonts/RMU-AvusProMedium.41aabe4.woff";